module.exports = __webpack_public_path__ + "img/rvt_buynow.0ccdaee6.jpg";